'use strict';

var Collection = require('base/Colido.Collection');
var SystemLanguageModel = require('../models/system-language');

/**
 * Collection for system languages
 *
 * @category   Collection
 * @module     global
 * @copyright  Copyright (c) 2016, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@h-m.io>
 */
var SystemLanguagesCollection = Collection.extend({
    model: SystemLanguageModel,
    name: 'global:system-languages',
});

module.exports = SystemLanguagesCollection;